import * as React from "react";
import { forwardRef } from "react";
const SvgStep6 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 6, stroke: "#222222" }), /* @__PURE__ */ React.createElement("path", { d: "M4 4L12 12", stroke: "#222222", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgStep6);
export default ForwardRef;
